import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../utils/immutable";
import { IAction } from "../../../models/Action";
import { compose } from "redux";

import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";

const { ACCOUNTS, REQUEST_STATE, GENERATE_OTP_RECEIVER, UIGP_OTP_VERIFIED } =
  STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.USER_ACCOUNT_REQUEST_RESET_PASSWORD]: (
    state: any,
    action: any
  ) => immutableSet([ACCOUNTS, LOADER_IDENTIFIER], true, state),
  [actionTypes.USER_ACCOUNT_REQUEST_RESET_PASSWORD_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse = [] as any[];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        if (data.resetPwdAllowed === true) {
          mappedResponse.push(data);
        }
      });
    return compose(
      immutableSet([ACCOUNTS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([ACCOUNTS, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.USER_ACCOUNT_REQUEST_RESET_PASSWORD_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([ACCOUNTS, LIST_IDENTIFIER], []),
      immutableSet([ACCOUNTS, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.FORCED_RESET_PWD]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.FORCED_RESET_PWD_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.FORCED_RESET_PWD_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_PASSWORD_REQUEST]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.RESET_PASSWORD_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.RESET_PASSWORD_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.GENERATE_UIGP_OTP_REQUEST]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.GENERATE_UIGP_OTP_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([REQUEST_STATE], IResponseState.SUCCESS),
      immutableSet([GENERATE_OTP_RECEIVER], action.payload.response)
    )(state);
  },
  [actionTypes.GENERATE_UIGP_OTP_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([REQUEST_STATE], IResponseState.ERROR),
      immutableSet([GENERATE_OTP_RECEIVER], "")
    )(state);
  },

  [actionTypes.VERIFY_RESET_UIGP_OTP_REQUEST]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.VERIFY_RESET_UIGP_OTP_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([REQUEST_STATE], IResponseState.SUCCESS),
      immutableSet([UIGP_OTP_VERIFIED], true)
    )(state);
  },
  [actionTypes.VERIFY_RESET_UIGP_OTP_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([REQUEST_STATE], IResponseState.ERROR),
      immutableSet([UIGP_OTP_VERIFIED], false)
    )(state);
  },

  [actionTypes.VERIFY_RESET_ARCOT_OTP_REQUEST]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.VERIFY_RESET_ARCOT_OTP_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(immutableSet([REQUEST_STATE], IResponseState.SUCCESS))(
      state
    );
  },
  [actionTypes.VERIFY_RESET_ARCOT_OTP_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(immutableSet([REQUEST_STATE], IResponseState.ERROR))(state);
  },

  [actionTypes.VERIFY_RESET_SEC_QUESTIONS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.VERIFY_RESET_SEC_QUESTIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(immutableSet([REQUEST_STATE], IResponseState.SUCCESS))(
      state
    );
  },
  [actionTypes.VERIFY_RESET_SEC_QUESTIONS_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(immutableSet([REQUEST_STATE], IResponseState.ERROR))(state);
  },

  [actionTypes.RESET_STATE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
